/**
 * Customer Account API OAuth 2.0 Authorization Code + PKCE 흐름에서 쓰는 순수 유틸.
 * https://shopify.dev/docs/api/customer
 */

const toBase64Url = (bytes: Uint8Array) => {
  let binary = "";
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });

  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

export const generateCodeVerifier = (): string => {
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  return toBase64Url(bytes);
};

export const generateCodeChallenge = async (verifier: string): Promise<string> => {
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));
  return toBase64Url(new Uint8Array(digest));
};

export const generateState = (): string => {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  return toBase64Url(bytes);
};